<template>
  <FullStorageModal v-if="storageIsFull" />
  <FeedbackModal v-else data-qa="feedback-modal" @close-parent="handleClose">
    <template #default="{ close }">
      <div class="modal-card">
        <header class="modal-card-head">
          <button class="button is-primary is-link is-paddingless" aria-label="close" @click="close(null, handleClose)">
            <i class="fas fa-times" aria-hidden="true" />
          </button>
        </header>
        <section class="modal-card-body" data-qa="error-feedback-modal">
          <i class="fa fa-exclamation-circle has-text-danger" aria-hidden="true" />
          <p v-if="message">
            {{ message }}
          </p>
          <p v-else data-qa="error-message">
            {{ errorMessage }}
          </p>
          <button
            type="button"
            class="button is-danger is-rounded"
            data-qa="close-feedback-button"
            @click="close(null, handleClose)"
          >
            {{ $t('cta.weiter') }}
            <i class="fas fa-arrow-right" aria-hidden="true" />
          </button>
        </section>
      </div>
    </template>
  </FeedbackModal>
</template>

<script>
export default {
  name: 'ErrorFeedbackModal',
  props: {
    success: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      isOffline: false
    }
  },
  computed: {
    errorMessage () {
      if (!this.isOffline) {
        return this.$t('allgemein.fehler')
      }
      return this.$t('allgemein.fehler_offline')
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
